import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import React, { memo } from "react";
import {
  CanbanBoardType,
  CanbanViewCardType,
  CanbanViewType,
  CardDiv,
} from "..";
import { ParseFilterState } from "../../..";
import { ParseObjectCard } from "../../../components/ParseObjectCard";

type Props = {
  view: CanbanViewType;
  state: ParseFilterState;
  column: CanbanBoardType;
  card: CanbanViewCardType;
};

export default memo((props: Props) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: props.card.key,
      data: { data: props.state.data, origin: props.column.key, type: "CARD" },
    });

  return (
    <CardDiv
      ref={setNodeRef}
      {...attributes}
      style={{
        transform: CSS.Translate.toString(transform),
        zIndex: isDragging ? 100 : "",
        position: isDragging ? "relative" : "static",
      }}
    >
      <ParseObjectCard
        listeners={listeners}
        isDragging={isDragging}
        object={props.card.object}
        imageField={props.view.imageField}
        titleFields={props.view.titleFields || props.state.config.titleFields}
        descriptionFields={
          props.view.descriptionFields || props.state.config.displayFields
        }
        onChange={() => props.state.data.reload()}
      />
    </CardDiv>
  );
});
